var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 93 95"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M30.221 1.116c2.7-1.1 4.821 2.274 3.35 4.79A40.8 40.8 0 0 0 28 26.554c0 22.644 18.356 41 41 41a40.8 40.8 0 0 0 18.845-4.58c2.588-1.343 5.852.945 4.618 3.587C84.737 83.096 67.957 94.553 48.5 94.553c-26.786 0-48.5-21.714-48.5-48.5 0-20.32 12.495-37.72 30.221-44.937",
    clipRule: "evenodd"
  })));
};
export default SvgMoon;